import { autobind } from 'core-decorators';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import bindCoreUI from '../provider/bindCoreUI';
import { UIProviderProps } from '../provider/UIProvider';
import bindField from './bindField';

export interface FieldProps {
    form?;
    name?;
    render;
    submit?;
    ui?: UIProviderProps;
}

@bindCoreUI
@bindField
@observer export class Field extends Component<FieldProps, any> {

    @autobind onChange(value) {
        const { form, name } = this.props;

        form.onChange(name, value);
    }

    @autobind async onSubmit(value) {
        const { form } = this.props;

        /*try {
            form.store.errors = [];
            await transformAndValidate(this.props.form.validator, toJS(form.store.data));

            form.onSubmit();
        } catch (e) {
            form.onError(e);
        }*/

        form.onSubmit();
    }

    render() {
        const { name, submit, form, ui } = this.props;

        if (submit) {
            return this.props.render({ submit: this.onSubmit, onChange: this.onChange, name, loading: form.store.isProcessing });
        }

        const ErrorMessageAdapter = ui.bindings.form.errorMessageBinding;
        const err = form.store.errors && form.store.errors.filter(e => e.property === name);
        const invalid = err && err.length > 0;

        return <>
            {this.props.render({
                onChange: this.onChange,
                name,
                invalid,
                loading: form.store.isProcessing,
                value: form.store.data[name] || ''
            })}

            { invalid && <ErrorMessageAdapter name={name} error={err[0]} /> }
        </>;
    }

}
